import { useCallback, useEffect, useState } from "react";
import { api } from "@/lib/api";
import { FairLending, ModelGov } from "@/components/governance/ModelGov";
import { FairZip } from "@/components/governance/FairZip";
import { CapRegister, ExamWorkbench, Replay } from "@/components/governance/ExamWorkbench";

const TABS = [["models", "Model governance & router", "/governance/models"], ["replay", "Historical replay", "/credit/history/replays"], ["fair", "Fair lending", "/governance/fair-lending"],
  ["exam", "Regulatory exam workbench", "/governance/exam"], ["caps", "Capability register", "/governance/capabilities"]];

export default function Governance() {
  const [tab, setTab] = useState("models");
  const [data, setData] = useState({});
  const url = TABS.find((t) => t[0] === tab)[2];
  const load = useCallback(() => api.get(url).then((r) => setData((d) => ({ ...d, [tab]: r.data }))), [url, tab]);
  useEffect(() => { load(); }, [load]);
  const d = data[tab];
  const onData = (v) => setData((x) => ({ ...x, [tab]: v }));
  return (
    <div className="flex-1 min-w-0 overflow-y-auto thin-scroll grid-bg" data-testid="governance-page">
      <div className="px-5 sm:px-8 py-8 space-y-5 max-w-[1600px]">
        <div className="rise">
          <div className="chip border-sky-200 bg-sky-50 text-sky-700 mb-3"><span className="w-1.5 h-1.5 rounded-full bg-sky-500" />Governed AI decision engine</div>
          <h1 className="font-display text-4xl lg:text-5xl font-extrabold tracking-tight hero-title pb-1">Governance & assurance</h1>
          <p className="text-sm text-slate-600 mt-2 max-w-3xl">Which model does what, how its answers are checked, how past decisions are replayed, how fair-lending risk is tested, how examiner requests are answered, and what has really been demonstrated.</p>
        </div>
        <div className="flex flex-wrap gap-1.5">{TABS.map(([k, l]) => <button key={k} data-testid={`gov-tab-${k}`} onClick={() => setTab(k)} className={`text-xs font-semibold px-3.5 py-2 rounded-xl border transition-colors ${tab === k ? "bg-slate-900 text-white border-slate-900" : "bg-white border-slate-200 text-slate-600 hover:border-slate-300"}`}>{l}</button>)}</div>
        {!d ? <div className="text-sm text-slate-500">Loading…</div> : <>
          {tab === "models" && <ModelGov d={d} />}
          {tab === "replay" && <Replay d={d} reload={load} />}
          {tab === "fair" && <><FairZip /><FairLending d={d} /></>}
          {tab === "exam" && <ExamWorkbench d={d} onData={onData} />}
          {tab === "caps" && <CapRegister d={d} onData={onData} />}
        </>}
      </div>
    </div>
  );
}
